import { CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { NULL_OPTION } from '@awp/constants';

export class RoadClosureService extends CrudService {
  constructor(mode: string) {
    super({ entityName: 'Road Closure', mode });
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: EntityProps): any {
    /* Do Nothing */
  }

  mapInitialValues(props: EntityProps): any {
    const { entity, ...rest } = props;

    let timestamp = new Date();
    if (entity.timestamp) {
      timestamp = new Date(Date.parse(entity.timestamp));
    }
    timestamp.setSeconds(0, 0);

    return {
      ...entity,
      status: undefined,
      program: isValueEmpty(entity.program) ? NULL_OPTION : entity.program,
      area: isValueEmpty(entity.area) ? NULL_OPTION : entity.area,
      segment: isValueEmpty(entity.segment) ? NULL_OPTION : entity.segment,
      fromPoint: isValueEmpty(entity.fromPoint) ? NULL_OPTION : entity.fromPoint,
      toPoint: isValueEmpty(entity.toPoint) ? NULL_OPTION : entity.toPoint,
      timestamp,
      comment: isValueEmpty(entity.comment) ? '' : entity.comment,
    };
  }
}
